import ButtonComponent from '../../../Buttons/ButtonComponent';

import wisealphaPic from '../../../../assets/brokers/wisealpha-pic.jpg';
import seedrsPic from '../../../../assets/brokers/seedrs-pic.jpg';
import goldexPic from '../../../../assets/brokers/goldex-pic.jpg';
import goldex from '../../../../assets/images/trusted_by/gold-ex.svg';
import wisealpha from '../../../../assets/images/trusted_by/wisealpha.svg';
import seedrs from '../../../../assets/images/trusted_by/seedrs.svg';

import Styles from '../styles.module.scss';

const BrokersBuildSection = () => (
  <div className={Styles['brokers-build-section']}>
    <div className={Styles.section}>
      <h2>Build Beautiful Experiences</h2>
      <p>Enterprise partners and how they've integrated CityFALCON data</p>
      <div className={Styles['flex-wrapper']}>
        <div className={Styles.column}>
          <img src={wisealphaPic} alt="" className={Styles.image} />
          <img src={wisealpha} alt="" className={Styles.logo} />
        </div>
        <div className={Styles.column}>
          <img src={seedrsPic} alt="" className={Styles.image} />
          <img src={seedrs} alt="" className={Styles.logo} />
        </div>
        <div className={Styles.column}>
          <img src={goldexPic} alt="" className={Styles.image} />
          <img src={goldex} alt="" className={Styles.logo} />
        </div>
      </div>
      <ButtonComponent
        path="/products/api/financial-news"
        value="Learn More"
        green
      />
    </div>
  </div>
);

export default BrokersBuildSection;
